// Shared constants for the stops bulk-import engine.
// Language codes follow the admin panel's list (admin/src/constant/Languages.tsx).

export const TAB_LANG = {
  english: "en",
  spanish: "es",
  german: "de",
  french: "fr",
  italian: "it",
  chinese: "zh",
};

// Canonical write order for language arrays (English first — tours.name[0] is
// what the Bokun cron reads as the tour name).
export const LANG_ORDER = ["en", "es", "de", "fr", "it", "zh"];

export const LIMITS = {
  imageBytes: 5_000_000, // multer image cap is DECIMAL 5,000,000 bytes (backend/src/utils/multer.ts:30)
  audioBytes: 50_000_000, // multer audio cap is DECIMAL 50,000,000 bytes (multer.ts:41)
  radiusMin: 5,
  radiusMax: 500,
  radiusHardMax: 2000, // above this = blocker (a 45km geofence is always a typo)
  proximityKm: 30,
  minAudioSeconds: 15, // below this = warning (manifest durations)
  maxJsonBytes: 90 * 1024, // backend effective JSON limit is 100KB (server.ts:27) — keep headroom
  freeStopsDefault: 3, // production lock pattern: first 3 stops free
  minStops: 2, // singleTourDirection rejects tours with < 2 stops
};

export const DEFAULT_BASE_URL = "https://connect.trippytourguide.com";
export const CDN_URL = "https://trippy-tour-app-media.lon1.digitaloceanspaces.com";


